import useMount from '@src/utils/hooks/use-mount';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { observable } from 'mobx';
import DateUtil from '@src/utils/date-util';

class DrawRecordListModalStore extends BaseModalStore {
  // 奖励列表
  // @observable recordList = [];
  recordList = [
    {
      prize_type: '3',
      prize_id: 2,
      create_time: 1715765120
    },
    {
      prize_type: '3',
      prize_id: 3,
      create_time: 1715765114
    },
    {
      prize_type: '1',
      prize_id: 3,
      create_time: 1715765068
    },
    {
      prize_type: '1',
      prize_id: 3,
      create_time: 1715765068
    },
    {
      prize_type: '1',
      prize_id: 3,
      create_time: 1715765068
    },
    {
      prize_type: '1',
      prize_id: 3,
      create_time: 1715765068
    },
    {
      prize_type: '1',
      prize_id: 3,
      create_time: 1715765068
    },
    {
      prize_type: '1',
      prize_id: 3,
      create_time: 1715765068
    },
    {
      prize_type: '1',
      prize_id: 3,
      create_time: 1715765068
    }
  ];

  @observable drawStore;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  getRecordDate = timestamp => {
    return DateUtil.formatDate(new Date(timestamp * 1000), 'yyyy/MM/dd');
  };

  getPrizeName = prizeId => {
    return this.drawStore.drawAwardList[+prizeId - 1].label;
  };

  use() {
    super.use();
    useMount(() => {});
  }
}

export default DrawRecordListModalStore;
